<div class="dialog-main">
  <div class="header mt-3 mb-5">
    <img
      src="/assets/svg/ico-chevron-back-outline.svg"
      alt="back button"
      class="pointer-cursor pb-64"
      (click)="stepper === 0 && !isCardActive ? closeDialog() : navigateBack()"
    />
    <div class="dialog-details col-10">
      <h2 class="modal-title text-center heading2 mr-5">
        <div>
          <app-with-tooltip [showHelpCursor]="true">
            {{ name }}
          </app-with-tooltip>
        </div>
        <div>
          <b>
            {{ title }}
          </b>
        </div>
      </h2>
    </div>
  </div>
  <div
    class="rounded-top body-container d-flex justify-content-center align-items-center"
    *ngIf="bodyText !== 'BLOCK_LIST_REQUIRES_MOBILE_APP' | translate; else largerMinHeight"
  >
    <div class="body-text mx-2">
      <h1>
        <b>{{ bodyText }}</b>
      </h1>
      <br />
      <p class="text">
        {{ footerText }}
      </p>
      <br />
    </div>
  </div>

  <ng-template #largerMinHeight>
    <div
      class="rounded-top body-container d-flex justify-content-center align-items-center"
      style="min-height: 45vh !important; margin-top: 50px !important"
    >
      <div class="body-text mx-2">
        <h1>
          <b>{{ bodyText }}</b>
        </h1>
        <br />
        <p class="text">
          {{ footerText }}
        </p>
        <br />
      </div>
    </div>
  </ng-template>

  <ng-container [ngSwitch]="stepper">
    <ng-container *ngSwitchCase="0">
      <div class="row my-2">
        <div class="col-12 my-1">
          <button
            class="btn btn-danger px-3 w-100 done-btn"
            type="button"
            (click)="deleteUser()"
          >
            {{ confirmBtn }}
          </button>
        </div>
      </div>

      <div class="row my-2">
        <div class="col-12 my-1">
          <button
            type="button"
            (click)="closeDialog()"
            class="add-button px-5 py-3 mt1 mb-4 w-100"
          >
            <strong> {{ cancelBtn }} </strong>
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="1">
      <div class="row my-2">
        <div class="col-12 my-1">
          <button
            class="btn btn-danger px-3 w-100 done-btn"
            type="button"
            (click)="openDefaultPopup()"
          >
            {{ confirmBtn }}
          </button>
        </div>
      </div>

      <div class="row my-2">
        <div class="col-12 my-1">
          <button
            type="button"
            (click)="navigateNext()"
            class="add-button px-5 py-3 mt1 mb-4 w-100"
          >
            <strong> {{ cancelBtn }} </strong>
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="2">
      <div class="row my-2">
        <div class="col-12 my-1"></div>
      </div>

      <div class="row my-2">
        <div class="col-12 my-1">
          <button
            type="button"
            (click)="closeDialog()"
            class="add-button px-5 py-3 mt1 mb-4 w-100"
          >
            <strong> {{ cancelBtn }} </strong>
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
